import React, {Component} from 'react';
import {
  Badge,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button
} from 'reactstrap';
import {Link} from 'react-router-dom';
import Grid from '../../../components/Grid/';
import {SURVEY_TYPES, SOUTHERN_CALIFORNIA_PROPERTY_ZONES, ARIZONA_PROPERTY_ZONES} from '../../../constants';
import {getUsers as APIGetUsers} from '../../../gateways/users';


class List extends Component {

  constructor(props) {
    super(props);

    let currentPage = 1;

    this.state = {
      data: [],
      currentPage: currentPage,
      maxPage: 1,
      searchText: "",
      limit: 10,
      filters: {
        search: "",
        union_flg: "",
        luxury_flg: "",
        survey_type: "",
        zone: "",
        join_surveys: ""
      }
    };

    this.onSubmitFilters = this.onSubmitFilters.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
  }

  fetchData() {
    APIGetUsers({ limit: this.state.limit, page: this.state.currentPage, ...this.state.filters })
    .then(result => {
      let hotels = result.data.hotels.map((hotel) => {
        return {
          ...hotel,
          ...hotel.User,
          hotel_id: hotel.id,
          user_id: hotel.User.id
        }
      });
      this.setState({
        data: hotels,
        maxPage: result.pages,
        total: result.total
      });
    });
  }

  componentWillMount() {
    this.fetchData();
  }

  getGridButtons(row) {
    return (
      <div>
        <Link to={'/users/view/' + row.user_id + '/' + row.hotel_id} ><Button className="btn btn-sm"><i className="fa fa-eye"></i>&nbsp;View</Button></Link>
      </div>
    );
  }

  onChangePage(page) {
    this.setState({
      currentPage: page
    }, this.fetchData);
  }

  onSubmitFilters(filters) {
    this.setState({
      currentPage: 1,
      filters: {
        ...this.state.filters,
        ...filters
      }
    }, this.fetchData);
  }

  render() {
    let url = '/users';
    let columns = [{
        key: "tools",
        type: "custom",
        render: (row) => this.getGridButtons(row),
        minWidth: "150px"
      },
      {
        key: "email",
        type: "string",
        name: "Email",
        minWidth: "150px"
      },
      {
        key: "firstname",
        type: "string",
        name: "First name",
        minWidth: "150px"
      },
      {
        key: "lastname",
        type: "string",
        name: "Last name",
        minWidth: "150px"
      },
      {
        key: "is_hard_copy_result",
        type: "string",
        query: {
          true: "Yes",
          false: "No"
        },
        name: "Hard Copy Result?"
      },
      {
        key: "propertyname",
        type: "string",
        name: "Property Name",
        minWidth: "150px"
      },
      {
        key: "contact_name",
        type: "string",
        name: "Contact Name",
        minWidth: "150px"
      },
      {
        key: "contact_email",
        type: "string",
        name: "Contact Email",
        minWidth: "150px"
      },
      {
        key: "phone",
        type: "string",
        name: "Phone",
        minWidth: "150px"
      },
      {
        key: "luxury_flg",
        type: "string",
        query: {
          true: "Yes",
          false: "No"
        },
        name: "Luxury?"
      },
      {
        key: "union_flg",
        type: "string",
        query: {
          true: "Yes",
          false: "No"
        },
        name: "Union?"
      },
      {
        key: "no_of_room",
        type: "string",
        name: "# of Rooms"
      },
      {
        key: "zone_id",
        type: "string",
        name: "Zone"
      },
      {
        key: "createdAt",
        type: "datetime",
        name: "Registration date",
        minWidth: "150px"
      }
    ];

    let filter = {
      fields: [
        {
          "id": "search",
          "text": "Search",
          "type": "text"
        },
        {
          "id": "join_surveys",
          "text": "Participate?",
          "type": "select",
          "options": [
            { value: 1, text: "Yes" },
            { value: 0, text: "No" }
          ]
        },
        {
          "id": "survey_type",
          "text": "Survey Type",
          "type": "select",
          "options": SURVEY_TYPES.map((surveyType) => {
            return { value: surveyType.key, text: surveyType.name}
          })
        },
        {
          "id": "union_flg",
          "text": "Union?",
          "type": "select",
          "options": [
            { value: 1, text: "Yes" },
            { value: 0, text: "No" }
          ]
        },
        {
          "id": "zone",
          "text": "Zone",
          "type": "select",
          "options": SOUTHERN_CALIFORNIA_PROPERTY_ZONES
          .concat(ARIZONA_PROPERTY_ZONES).map((zone) => {
            return { value: zone.key, text: zone.name };
          })
        },
        {
          "id": "luxury_flg",
          "text": "Luxury?",
          "type": "select",
          "options": [
            { value: 1, text: "Yes" },
            { value: 0, text: "No" }
          ]
        }
      ]
    };

    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                <Grid
                  columns={columns}
                  filter={filter}
                  onSubmitFilters={this.onSubmitFilters}
                  onChangePage={this.onChangePage}
                  data={this.state.data}
                  currentPage={this.state.currentPage}
                  perPage={this.state.limit}
                  total={this.state.total} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/views/Users/List/List.js